import React, { useEffect, useState } from "react";

import BannerImage from "@/src/components/locate-us/bannerImage";
import { testApiService } from "@/src/lib/api-services/testApiServices";
import DashboardLayout from "@/src/components/layout/DashboardLayout";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";

import TestDetails from "@/src/components/test/testDetails";
import useAuth from "@/src/lib/hooks/useAuth";
import dynamic from "next/dynamic";
import TestHeader from "@/src/components/test/testHeader";
import { getCookieValue } from "@/src/components/common/common";
import MobileApps from "@/src/modules/home/mobileApps";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

TestView.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

const TestActionAndControlSection = dynamic(() =>
    import("@/src/components/test/testActionAndControlSection")
);

const Suggestions = dynamic(() => import("@/src/components/test/suggestions"));

export default function TestView({ data: testDetails }) {
    const { isLoggedIn } = useAuth();
    const isMobile = useBreakpoint("sm");
    const [currentType, setCurrentType] = useState(null);

    const [currentTest, setCurrentTest] = useState(null);
    const [testVariantDetails, setTestVariantDetails] = useState(
        testDetails?.configTest?.find(
            (test) => test?.itemId === testDetails?.defaultItemId
        )
    );

    const handleTestSelection = (test) => {
        setCurrentTest(test);
    };

    useEffect(() => {
        if (testDetails) {
            const defaultTestVariant = testDetails?.configTest.find(
                (test) => test?.itemId === testDetails?.defaultItemId
            );
            setTestVariantDetails(defaultTestVariant);
        }
    }, [testDetails]);

    const { configProductCard, bannerImage, bannerImageAlt } =
        testDetails || {};

    const testBannerImage =
        bannerImage || configProductCard?.categoryBannerImage || null;

    const testBannerImageAlt =
        bannerImageAlt || configProductCard?.productName || null;

    const testResponsiveBannerImage =
        bannerImage || configProductCard?.categoryBannerImageResponsive || null;

    useEffect(() => {
        if (currentTest && testDetails) {
            const selectedTestVariantDetails = testDetails.configTest.find(
                (test) => test?.itemId === currentTest?.itemId
            );

            setTestVariantDetails(selectedTestVariantDetails);
        }
    }, [currentTest]);

    const renderTestDetails = !!testDetails && (
        <TestDetails
            testDetails={testDetails}
            selectedTest={currentTest}
            testVariantDetails={testVariantDetails}
            ISLOGGEDIN={isLoggedIn}
            currentType={currentType}
        />
    );

    const renderTestActionAndControlSection = !!testDetails && (
        <TestActionAndControlSection
            testDetails={testDetails}
            handleTestSelection={handleTestSelection}
            currentTest={currentTest}
            ISLOGGEDIN={isLoggedIn}
            setCurrentType={setCurrentType}
        />
    );

    //console.log(testDetails, 'testDetailsssssssssss');

    return (
        <>
            <div className="bg-slate-50">
                {testBannerImage ? (
                    <BannerImage
                        src={`${NEXT_IMAGE_CDN}/${
                            isMobile
                                ? testResponsiveBannerImage
                                : testBannerImage
                        }`}
                        //src="https://via.placeholder.com/800x200.png?text=Sample+Banner"
                        alt={testBannerImageAlt}
                    />
                ) : (
                    <BannerImage alt="HOD Lab" />
                )}
                <div className="w-full max-w-6xl mx-auto px-4 pt-5 pb-10 md:pt-8 md:pb-16">
                    <div className="flex flex-col gap-5 md:gap-6 w-full">
                        {isMobile && (
                            <TestHeader
                                testDetails={testDetails}
                                selectedTest={currentTest}
                            />
                        )}

                        <div className="flex md:flex-row flex-col md:items-start gap-5 md:gap-6 w-full">
                            {isMobile ? (
                                <>
                                    {renderTestActionAndControlSection}
                                    {renderTestDetails}
                                </>
                            ) : (
                                <>
                                    {renderTestDetails}
                                    {renderTestActionAndControlSection}
                                </>
                            )}
                        </div>
                        {testDetails?.configUpSells &&
                            testDetails?.configUpSells.length > 0 && (
                                <Suggestions
                                    data={testDetails?.configUpSells}
                                    displayName={
                                        "This Test Is Also Included In"
                                    }
                                />
                            )}
                        {testDetails?.configCrossSells &&
                            testDetails?.configCrossSells.length > 0 && (
                                <Suggestions
                                    data={testDetails?.configCrossSells}
                                    displayName={"You May Also Avail"}
                                />
                            )}
                    </div>
                </div>
                <MobileApps />
            </div>
        </>
    );
}

// This ensures that the page is server-side rendered
export async function getServerSideProps(context) {
    const { test_slug } = context.query;
    let data = null;
    const sessionId = getCookieValue(context.req.headers.cookie, "connect.sid");

    try {
        const response = await testApiService.getTestDetails(
            {
                urlSlug: test_slug,
            },
            {
                headers: {
                    Cookie: `connect.sid=${sessionId}`,
                    "Content-Type": "application/json",
                },
            }
        );

        data = response?.data?.data;

        return {
            props: {
                data: {
                    ...data,
                    routerPath: `test/${test_slug}`,
                    urlSlug: test_slug,
                    headers: context?.req?.headers,
                },
            },
        };
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }
}
